import { Body, Container, H2, Stack } from "@carrotfertility/carotene"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { IlloUnderwaterPlants } from "components/views/atoms/Illustrations"
import React from "react"
import { BenefitEnrollmentFlowModalBackButton, BenefitEnrollmentModalContinueButton } from "../shared"
import { Steps } from "../workflow/steps"
import { useBenefitEnrollment } from "../../context/enrollment/BenefitEnrollmentContext"
import { FlexRowCenter } from "../../views/atoms/Atoms"

const viewName = Steps.HRA_INELIGIBLE

export const HraIneligibleStep = (): JSX.Element => {
  const { setNextStep, goBackTwoSteps } = useStateMachine(viewName, null)
  const { deductibleFlowType, hraEligibility } = useBenefitEnrollment()
  const yourOrYourPartners = hraEligibility?.memberHraEligibility ? "your partner's" : "your"
  const yourOrTheir = hraEligibility?.memberHraEligibility ? "their" : "your"
  const dontOrDoesnt = hraEligibility?.memberHraEligibility ? "your partner doesn't" : "you don't"
  return (
    <Stack>
      <Container>
        <BenefitEnrollmentFlowModalBackButton handleGoBack={goBackTwoSteps} />
      </Container>
      <FlexRowCenter>
        <IlloUnderwaterPlants />
      </FlexRowCenter>
      <H2>{`It looks like ${yourOrYourPartners} insurance plan is subject to some restrictions.`}</H2>
      <Body>
        {`Because ${dontOrDoesnt} get ${yourOrTheir} health coverage through an employer, Carrot funds can't legally be used for ${yourOrTheir} qualified medical expenses (QMEs).`}
      </Body>
      <Body>
        {
          "QMEs include fertility or preservation care related to an infertility diagnosis, as well as preservation care related to medical necessity. Funds can be used for other types of eligible care."
        }
      </Body>
      <BenefitEnrollmentModalContinueButton onClick={() => setNextStep(viewName, deductibleFlowType)} />
    </Stack>
  )
}
